function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0 and the Server Side Public License, v 1; you may not use this file except
 * in compliance with, at your election, the Elastic License 2.0 or the Server
 * Side Public License, v 1.
 */

import { css } from '@emotion/react';
import { euiFormControlStyles } from '../form.styles';
var _ref = process.env.NODE_ENV === "production" ? {
  name: "u3qgm8-withToggle",
  styles: "&::-ms-reveal{display:none;};label:withToggle;"
} : {
  name: "u3qgm8-withToggle",
  styles: "&::-ms-reveal{display:none;};label:withToggle;",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export var euiFieldPasswordStyles = function euiFieldPasswordStyles(euiThemeContext) {
  var formStyles = euiFormControlStyles(euiThemeContext);
  return {
    euiFieldPassword: /*#__PURE__*/css(formStyles.shared, " &:invalid{", formStyles.invalid, ";}&:focus{", formStyles.focus, ";}&:disabled{", formStyles.disabled, ";}&[readOnly]{", formStyles.readOnly, ";}&:autofill{", formStyles.autoFill, ";};label:euiFieldPassword;"),
    // Only remove Edge's internal reveal button if we're providing a custom one
    withToggle: _ref,
    // Skip the css() on the default height to avoid generating a className
    uncompressed: formStyles.uncompressed,
    compressed: /*#__PURE__*/css(formStyles.compressed, ";label:compressed;"),
    // Skip the css() on the default width to avoid generating a className
    formWidth: formStyles.formWidth,
    fullWidth: /*#__PURE__*/css(formStyles.fullWidth, ";label:fullWidth;"),
    // Layout modifiers
    inGroup: /*#__PURE__*/css(formStyles.inGroup, ";label:inGroup;")
  };
};